<template>
    <div class="footbarwrap" :class="{'zIndex':show}" v-if="button1 || button2">
        <div class="footbarbox">
            <ul class="footbar">
                <li class="btnTop" v-if="button1">
                    <a href="javascript:;" v-if="button1.type == 0" @click="btnClickEvent(button1.url)">{{button1.name}}</a>
                    <a href="javascript:;" v-if="button1.type == 1" @click="shareEvent(button1)">{{button1.name}}</a>
                </li>
                <li class="btnBot" v-if="button2" :class="{'btnBotNo':!button1}">
                    <div class="btnzdy" v-if="button2.type == 0">
                        <a :href="button2.url">{{button2.name}}</a>
                    </div>
                    <div class="btnzdy" v-if="button2.type == 1">
                        <a href="javascript:;" @click="shareEvent(button2)">{{button2.name}}</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <share-mask v-if="shareFlag" :share="sharedata"></share-mask>
</template>
<script>
import ShareMask from './ShareMask.vue';
import {miniBack} from '@/tools/miniback.js'
export default {
    props: {
        button1: Object,
        button2: Object,
        // download: Boolean,
        show: Boolean
    },
    data() {
        // var reg = /^daojia:.+/.test(window.downloadUrl)
        // if (window.isAppFlag && !reg) {
        //     window.downloadUrl = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(window.downloadUrl);
        // }
        return {
            share: null,
            shareFlag: false,
            sharedata: null
            // url: window.downloadUrl
        }
    },
    events: {
        hideEvent() {
            var that = this;
            that.shareFlag = false;
        }
    },
    methods: {
        //点击预约保洁
        btnClickEvent(jumpUrl){
            if(window.channel && window.channel == 'webChat'){
                //如果judgeSource == 'activity' 在小程序中点击领券其他优惠券时跳到活动主会场 否则跳到小程序首页
                if(window.judgeSource && window.judgeSource == 'activity'){
                    window.location.href=jumpUrl;
                }else{
                    // wx.miniProgram.navigateTo({url:'/pages/index/index'});
                    miniBack()
                }
            }else{
                window.location.href=jumpUrl;
                //alert('其他'+jumpUrl);
            }
        },
        //点击预约保洁
        // btnClickEvent(jumpUrl){
        //     if (typeof wx == 'object'){
        //         wx.miniProgram.getEnv(function(res) {
        //             if (res.miniprogram){   // 小程序环境
        //                 wx.miniProgram.navigateTo({url:'/pages/index/index'});
        //             }else{
        //                 window.location.href=jumpUrl;
        //             }
        //         })
        //     }else{
        //         window.location.href=jumpUrl;
        //     }
        // },
        //点击分享
        shareEvent(buttondata) {
            var that = this;
            that.shareFlag = true;
            that.sharedata = buttondata;
            that.$dispatch('maskFlagEvent', true);
            if (typeof wx == 'object'){
                wx.miniProgram.getEnv(function(res) {
                    if (res.miniprogram){   // 小程序环境
                        wx.miniProgram.postMessage({
                            data: {
                                shareTitle : window.shareAppData.title,
                                shareImg: window.shareAppData.iconUrl,
                                shareUrl: window.shareAppData.shareUrl
                            } 
                        })
                    }
                })
            }
        }
    },
    components: {
        ShareMask
    }
}
</script>



// WEBPACK FOOTER //
// Btn.vue?63ab59bf